(function () {
  function initIngredientsCarousels(scope) {
    var carousels = (scope || document).querySelectorAll('[data-kefey-ingredients]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-kefey-ingredients-track]');
      if (!track) return;
      var prev = carousel.querySelector('[data-kefey-prev]');
      var next = carousel.querySelector('[data-kefey-next]');
      var dotsRoot = carousel.parentElement ? carousel.parentElement.querySelector('[data-kefey-ingredients-dots]') : null;
      var dots = dotsRoot ? dotsRoot.querySelectorAll('[data-kefey-dot]') : [];

      function slideStep() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
        if (isNaN(gap)) gap = 0;
        var port = track.clientWidth;
        if (port > 0) return Math.max(1, Math.floor(port + gap));
        var firstCard = track.querySelector(':scope > *');
        var cardW = firstCard ? firstCard.getBoundingClientRect().width : 0;
        if (cardW <= 0) return Math.max(220, 280);
        return Math.floor(cardW + gap);
      }

      function slideCount() {
        return track.children.length;
      }

      function currentSlide() {
        var st = slideStep();
        if (st <= 0) return 0;
        var idx = Math.round(track.scrollLeft / st);
        var max = Math.max(0, slideCount() - 1);
        return Math.max(0, Math.min(max, idx));
      }

      function goToSlide(index) {
        var st = slideStep();
        if (st <= 0) return;
        var max = Math.max(0, slideCount() - 1);
        index = Math.max(0, Math.min(max, index));
        track.scrollTo({ left: index * st, behavior: 'smooth' });
      }

      function updateDots() {
        if (!dots.length) return;
        var st = slideStep();
        if (st <= 0) return;
        var idx = currentSlide();
        dots.forEach(function (dot, i) {
          var on = i === idx;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      var scrollRaf = 0;
      function onTrackScroll() {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          updateDots();
        });
      }

      track.addEventListener('scroll', onTrackScroll, { passive: true });

      if (prev) {
        prev.addEventListener('click', function () {
          goToSlide(currentSlide() - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          goToSlide(currentSlide() + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-kefey-dot') || '0', 10);
          if (isNaN(i)) i = 0;
          goToSlide(i);
        });
      });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          updateDots();
        });
        ro.observe(track);
      }

      requestAnimationFrame(updateDots);
    });
  }

  function initCertCarousels(scope) {
    var carousels = (scope || document).querySelectorAll('[data-kefey-certs]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-kefey-certs-track]');
      if (!track) return;

      var prev = carousel.querySelector('[data-kefey-certs-prev]');
      var next = carousel.querySelector('[data-kefey-certs-next]');
      var step = function () {
        return Math.max(240, Math.floor(track.clientWidth * 0.9));
      };

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });
  }

  function initFinalCtaSlider(scope) {
    var sliders = (scope || document).querySelectorAll('[data-kefey-beforeafter]');
    sliders.forEach(function (slider) {
      var track = slider.querySelector('[data-kefey-ba-track]');
      var handle = slider.querySelector('[data-kefey-ba-handle]');
      if (!track || !handle) return;

      var defaultPos = parseFloat(slider.getAttribute('data-default-position') || '50');
      var value = isNaN(defaultPos) ? 50 : defaultPos;
      var dragging = false;

      function clamp(num, min, max) {
        return Math.min(max, Math.max(min, num));
      }

      function setValue(next) {
        value = clamp(next, 0, 100);
        slider.style.setProperty('--pos', value + '%');
        handle.setAttribute('aria-valuenow', String(Math.round(value)));
      }

      function pointToValue(clientX) {
        var rect = track.getBoundingClientRect();
        if (rect.width <= 0) return value;
        return ((clientX - rect.left) / rect.width) * 100;
      }

      function onPointerMove(clientX) {
        setValue(pointToValue(clientX));
      }

      function onMouseMove(evt) {
        if (!dragging) return;
        onPointerMove(evt.clientX);
      }

      function onTouchMove(evt) {
        if (!dragging || !evt.touches || !evt.touches.length) return;
        evt.preventDefault();
        onPointerMove(evt.touches[0].clientX);
      }

      function endDrag() {
        dragging = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', endDrag);
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', endDrag);
      }

      function startDrag(evt) {
        evt.preventDefault();
        dragging = true;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', endDrag);
        document.addEventListener('touchmove', onTouchMove, { passive: false });
        document.addEventListener('touchend', endDrag);
      }

      slider.addEventListener('click', function (evt) {
        if (dragging) return;
        if (evt.target === handle || handle.contains(evt.target)) return;
        onPointerMove(evt.clientX);
      });

      handle.addEventListener('mousedown', startDrag);
      handle.addEventListener('touchstart', function (evt) {
        if (!evt.touches || !evt.touches.length) return;
        startDrag(evt);
      }, { passive: false });

      handle.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowLeft') {
          evt.preventDefault();
          setValue(value - 2);
        } else if (evt.key === 'ArrowRight') {
          evt.preventDefault();
          setValue(value + 2);
        }
      });

      setValue(value);
    });
  }

  function initFaqAria(scope) {
    var items = (scope || document).querySelectorAll('.kefey-product-faq__item');
    items.forEach(function (item) {
      var summary = item.querySelector('.kefey-product-faq__summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', item.hasAttribute('open') ? 'true' : 'false');
      item.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', item.hasAttribute('open') ? 'true' : 'false');
      });
    });
  }

  function formatMoney(cents, moneyFormat) {
    var value = (Number(cents || 0) / 100).toFixed(2);
    if (!moneyFormat) return '$' + value;
    if (moneyFormat.indexOf('{{amount}}') !== -1) return moneyFormat.replace('{{amount}}', value);
    if (moneyFormat.indexOf('{{ amount }}') !== -1) return moneyFormat.replace('{{ amount }}', value);
    return '$' + value;
  }

  var KEFEY_PACK_SIZES = [1, 2, 3, 4, 5, 6];

  function getPackFromVariant(variant) {
    var source = [];
    if (variant && variant.title) source.push(String(variant.title));
    if (variant && Array.isArray(variant.options)) source = source.concat(variant.options.map(String));
    var haystack = source.join(' ').toLowerCase();

    for (var i = KEFEY_PACK_SIZES.length - 1; i >= 0; i -= 1) {
      var pack = KEFEY_PACK_SIZES[i];
      var pattern = new RegExp('\\b' + pack + '\\s*[- ]?\\s*packs?|packs?\\s*' + pack + '\\b');
      if (pattern.test(haystack)) return pack;
    }
    return null;
  }

  /**
   * Variants are now priced as full pack totals (e.g. 1-pack $39, 2-pack $78, etc.).
   * Cart quantity is always 1 per variant line item.
   */
  function cartQuantityForPack(variant, pack) {
    return 1;
  }

  function allocationPlanId(allocation) {
    if (!allocation) return null;
    var raw =
      allocation.selling_plan_id != null
        ? allocation.selling_plan_id
        : allocation.selling_plan && allocation.selling_plan.id != null
          ? allocation.selling_plan.id
          : null;
    return normalizeSellingPlanId(raw);
  }

  function variantHasPlanId(variant, planId) {
    if (!variant || planId == null || !Array.isArray(variant.selling_plan_allocations)) return false;
    return variant.selling_plan_allocations.some(function (allocation) {
      return allocationPlanId(allocation) === planId;
    });
  }

  /**
   * Shopify /cart/add.js expects a numeric selling plan id (Recharge uses Shopify selling plans).
   */
  function normalizeSellingPlanId(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'number' && !isNaN(raw)) return raw;
    var s = String(raw).trim();
    var gid = /SellingPlan\/(\d+)/.exec(s);
    if (gid) return Number(gid[1]);
    var n = parseInt(s, 10);
    return isNaN(n) ? null : n;
  }

  function sellingPlanMapFromModule(module) {
    var map = {};
    KEFEY_PACK_SIZES.forEach(function (pack) {
      map[pack] = {
        planId: normalizeSellingPlanId(module.getAttribute('data-plan-pack-' + pack)),
        groupId: normalizeSellingPlanId(module.getAttribute('data-plan-group-pack-' + pack))
      };
    });
    return map;
  }

  function discountMapFromModule(module, displayDiscount) {
    var map = {};
    KEFEY_PACK_SIZES.forEach(function (pack) {
      var raw = parseInt(module.getAttribute('data-discount-pack-' + pack) || '', 10);
      map[pack] = isNaN(raw) ? displayDiscount : raw;
    });
    return map;
  }

  function explicitVariantIdsFromModule(module) {
    var ids = {};
    KEFEY_PACK_SIZES.forEach(function (pack) {
      var raw = module.getAttribute('data-variant-pack-' + pack);
      if (!raw) return;
      var id = parseInt(String(raw).trim(), 10);
      if (!isNaN(id) && id > 0) ids[pack] = id;
    });
    return ids;
  }

  function buildVariantMapByPack(variants, fallbackVariant, explicitIds) {
    var map = {};
    var idLookup = explicitIds || {};

    KEFEY_PACK_SIZES.forEach(function (pack) {
      var explicitId = idLookup[pack];
      if (!explicitId) return;
      var found = variants.find(function (variant) {
        return Number(variant.id) === Number(explicitId);
      });
      if (found) map[pack] = found;
    });

    variants.forEach(function (variant) {
      var pack = getPackFromVariant(variant);
      if (pack && !map[pack]) map[pack] = variant;
    });

    var hasMappedPack = KEFEY_PACK_SIZES.some(function (pack) {
      return Boolean(map[pack]);
    });

    if (!hasMappedPack) {
      KEFEY_PACK_SIZES.forEach(function (pack) {
        map[pack] = fallbackVariant;
      });
      return map;
    }

    KEFEY_PACK_SIZES.forEach(function (pack) {
      if (map[pack]) return;
      var nearest = KEFEY_PACK_SIZES.map(function (candidate) {
        return map[candidate];
      }).find(Boolean);
      map[pack] = nearest || fallbackVariant;
    });

    return map;
  }

  var GUMMIES_BY_PACK = {
    1: 60,
    2: 120,
    3: 180,
    4: 240,
    5: 300,
    6: 360
  };

  function updatePackImage(module, pack, purchaseType, usePackImage) {
    var packImageEl =
      module.querySelector('[data-kefey-pack-image]') || module.querySelector('.kefey-purchase__image');
    if (!packImageEl) return;

    var nextSrc;
    if (purchaseType === 'one' && !usePackImage) {
      nextSrc =
        module.getAttribute('data-single-product-image') ||
        packImageEl.getAttribute('data-fallback-src');
    } else {
      nextSrc =
        module.getAttribute('data-pack-image-' + pack) ||
        module.getAttribute('data-single-product-image') ||
        packImageEl.getAttribute('data-fallback-src');
    }

    if (!nextSrc) return;

    var currentSrc = packImageEl.getAttribute('src') || '';
    var currentKey = currentSrc.split('?')[0].split('/').pop();
    var nextKey = nextSrc.split('?')[0].split('/').pop();
    if (currentKey && nextKey && currentKey === nextKey) return;

    packImageEl.removeAttribute('srcset');
    packImageEl.setAttribute('src', nextSrc);
  }

  function getPackImageUrl(module, pack, purchaseType, usePackImage) {
    if (purchaseType === 'one' && !usePackImage) {
      return module.getAttribute('data-single-product-image') || '';
    }
    return (
      module.getAttribute('data-pack-image-' + pack) ||
      module.getAttribute('data-single-product-image') ||
      ''
    );
  }

  function buildKefeyLineProperties(module, pack, purchaseType, sellingPlanId, usePackImage) {
    var packSize = purchaseType === 'one' && !usePackImage ? 1 : pack;
    var properties = {
      _kefey_purchase_type: purchaseType,
      _kefey_pack_size: String(packSize)
    };
    if (purchaseType === 'sub' && sellingPlanId != null) {
      properties._kefey_plan_id = String(sellingPlanId);
    }
    var imageUrl = getPackImageUrl(module, packSize, purchaseType, usePackImage);
    if (imageUrl) properties._kefey_pack_image = imageUrl;
    return properties;
  }

  function resolveOneTimeVariant(variants, fallbackVariant) {
    var available = variants.filter(function (v) {
      return v && v.available !== false;
    });
    var oneTime = available.find(function (v) {
      var title = String(v.title || '').toLowerCase();
      return title.indexOf('one-time') !== -1 || title.indexOf('one time') !== -1;
    });
    if (oneTime) return oneTime;

    var singles = available.filter(function (v) {
      return getPackFromVariant(v) == null;
    });
    var pool = singles.length ? singles : available;
    pool.sort(function (a, b) {
      var minA = a.quantity_rule && a.quantity_rule.min != null ? a.quantity_rule.min : 1;
      var minB = b.quantity_rule && b.quantity_rule.min != null ? b.quantity_rule.min : 1;
      return minA - minB;
    });
    return pool[0] || fallbackVariant;
  }

  function normalizePlanGroupId(allocation) {
    if (!allocation) return null;
    var rawGroupId =
      allocation.selling_plan_group_id != null
        ? allocation.selling_plan_group_id
        : allocation.selling_plan && allocation.selling_plan.selling_plan_group_id != null
          ? allocation.selling_plan.selling_plan_group_id
          : allocation.selling_plan && allocation.selling_plan.group_id != null
            ? allocation.selling_plan.group_id
            : null;
    return normalizeSellingPlanId(rawGroupId);
  }

  function matchAllocationByTarget(variant, target) {
    if (!variant || !Array.isArray(variant.selling_plan_allocations) || !variant.selling_plan_allocations.length) {
      return null;
    }
    var preferredPlanId = target && target.planId != null ? target.planId : null;
    var preferredGroupId = target && target.groupId != null ? target.groupId : null;
    if (preferredPlanId == null && preferredGroupId == null) return null;
    var allocations = variant.selling_plan_allocations;
    return allocations.find(function (allocation) {
      if (!allocation) return false;
      var rawId =
        allocation.selling_plan_id != null
          ? allocation.selling_plan_id
          : allocation.selling_plan && allocation.selling_plan.id != null
            ? allocation.selling_plan.id
            : null;
      var allocationPlanId = normalizeSellingPlanId(rawId);
      var allocationGroupId = normalizePlanGroupId(allocation);
      if (preferredPlanId != null && allocationPlanId === preferredPlanId) return true;
      if (preferredGroupId != null && allocationGroupId === preferredGroupId) return true;
      return false;
    }) || null;
  }

  function variantHasTarget(variant, target) {
    return Boolean(matchAllocationByTarget(variant, target));
  }

  function firstRecurringAllocation(variant) {
    if (!variant || !Array.isArray(variant.selling_plan_allocations)) return null;
    return (
      variant.selling_plan_allocations.find(function (a) {
        if (!a || !a.selling_plan) return false;
        if (a.selling_plan.recurring_deliveries === true) return true;
        var cat = String(a.selling_plan.category || '').toUpperCase();
        return cat === 'SUBSCRIPTION' || cat === 'SUBSCRIPTIONS';
      }) || variant.selling_plan_allocations[0] || null
    );
  }

  /**
   * Prefer a subscription (recurring) allocation so Recharge/Shopify Checkout gets the right plan
   * when multiple allocations exist (e.g. preorder vs subscribe).
   */
  function sellingPlanIdForCart(variant, target) {
    if (!variant || !Array.isArray(variant.selling_plan_allocations) || !variant.selling_plan_allocations.length) {
      return null;
    }
    var preferredPlanId = target && target.planId != null ? target.planId : null;
    if (preferredPlanId != null || (target && target.groupId != null)) {
      var preferredAllocation = matchAllocationByTarget(variant, target);
      if (!preferredAllocation) return null;
      return normalizeSellingPlanId(
        preferredAllocation.selling_plan_id != null
          ? preferredAllocation.selling_plan_id
          : preferredAllocation.selling_plan && preferredAllocation.selling_plan.id != null
            ? preferredAllocation.selling_plan.id
            : null
      );
    }
    var allocations = variant.selling_plan_allocations;
    function isSubscriptionAllocation(a) {
      if (!a) return false;
      var sp = a.selling_plan;
      if (!sp || typeof sp !== 'object') return false;
      if (sp.recurring_deliveries === true) return true;
      var cat = String(sp.category || '').toUpperCase();
      if (cat === 'SUBSCRIPTION' || cat === 'SUBSCRIPTIONS') return true;
      return false;
    }
    var chosen = allocations.find(isSubscriptionAllocation);
    if (!chosen) chosen = allocations[0];
    var rawId =
      chosen.selling_plan_id != null
        ? chosen.selling_plan_id
        : chosen.selling_plan && chosen.selling_plan.id != null
          ? chosen.selling_plan.id
          : null;
    return normalizeSellingPlanId(rawId);
  }

  function initPurchaseModule(scope) {
    var modules = (scope || document).querySelectorAll('[data-kefey-purchase]');
    modules.forEach(function (module) {
      var jsonEl = module.querySelector('[data-kefey-product-json]');
      if (!jsonEl) return;

      var product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (err) {
        return;
      }
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return;

      var variants = product.variants;
      var fallbackVariant = variants[0];
      var map = buildVariantMapByPack(variants, fallbackVariant, explicitVariantIdsFromModule(module));

      var defaultPack = parseInt(module.getAttribute('data-default-pack') || '1', 10);
      if (!KEFEY_PACK_SIZES.includes(defaultPack)) defaultPack = 1;
      var defaultType = module.getAttribute('data-default-purchase-type') === 'one' ? 'one' : 'sub';
      var displayDiscount = parseInt(module.getAttribute('data-discount-percent') || '10', 10);
      if (isNaN(displayDiscount)) displayDiscount = 10;
      var discountByPack = discountMapFromModule(module, displayDiscount);
      var moneyFormat = module.getAttribute('data-money-format') || '${{amount}}';
      var displayCompareFallback = module.getAttribute('data-display-compare') || '';
      var rawBadgeText = module.getAttribute('data-badge-text') || 'OFF & Cancel Anytime';
      var badgeSuffix = rawBadgeText.replace(/^\s*\d+\s*%?\s*/i, '').trim() || 'OFF & Cancel Anytime';
      var sellingPlanByPack = sellingPlanMapFromModule(module);

      var state = {
        pack: defaultPack,
        type: defaultType,
        // Start with the default pack selected (e.g. 2 Pack) for both purchase types.
        oneTimeUsesPack: true
      };

      var subPlan = module.querySelector('[data-plan="sub"]');
      var onePlan = module.querySelector('[data-plan="one"]');
      var packButtons = module.querySelectorAll('.kefey-purchase__pack');
      var variantInput = module.querySelector('[data-selected-variant-id]');
      var subEachEl = module.querySelector('[data-sub-each]');
      var subTotalEl = module.querySelector('[data-sub-total]');
      var subCompareEl = module.querySelector('[data-sub-compare]');
      var subBadgeEl = module.querySelector('[data-sub-badge]');
      var oneEachEl = module.querySelector('[data-one-each]');
      var onePriceLabelEl = module.querySelector('[data-one-price-label]');
      var cta = module.querySelector('[data-kefey-checkout]');
      var packsEl = module.querySelector('[data-subscribe-packs]');
      var gummiesBadgeEl = module.querySelector('[data-kefey-gummies-badge]');
      var gummiesCountEl = module.querySelector('[data-kefey-gummies-count]');

      function resolveVariantForPack(pack) {
        var preferredTarget = sellingPlanByPack[pack] || null;
        var candidate = map[pack] || fallbackVariant;
        if (!preferredTarget || (preferredTarget.planId == null && preferredTarget.groupId == null)) return candidate;
        if (candidate && variantHasTarget(candidate, preferredTarget)) return candidate;
        var byPlan = variants.find(function (v) {
          return variantHasTarget(v, preferredTarget);
        });
        return byPlan || candidate;
      }

      function computeSubscribePricing(pack) {
        var variant = resolveVariantForPack(pack);
        if (!variant) return null;

        var basePrice = Number(variant.price || 0);
        var baseCompare = Number(variant.compare_at_price || 0);
        var packNum = pack && pack > 0 ? pack : 1;
        var preferredTarget = sellingPlanByPack[pack] || null;
        var packDiscount = discountByPack[pack];
        if (typeof packDiscount !== 'number' || isNaN(packDiscount)) packDiscount = displayDiscount;
        var sellingPlanId = sellingPlanIdForCart(variant, preferredTarget);
        if (sellingPlanId == null || !variantHasPlanId(variant, sellingPlanId)) {
          sellingPlanId = sellingPlanIdForCart(variant, null);
        }

        var subTotal = basePrice;
        var subCompareTotal = baseCompare > 0 ? baseCompare : basePrice;
        var allocation = null;

        if (sellingPlanId != null && Array.isArray(variant.selling_plan_allocations)) {
          allocation = matchAllocationByTarget(variant, preferredTarget);
          if (!allocation) allocation = firstRecurringAllocation(variant);
          if (allocation) {
            var allocId = allocationPlanId(allocation);
            if (allocId != null && variantHasPlanId(variant, allocId)) sellingPlanId = allocId;
          }
          if (allocation && allocation.compare_at_price) {
            subCompareTotal = Number(allocation.compare_at_price);
          }
        }

        if (allocation && allocation.price) {
          subTotal = Number(allocation.price);
        } else if (packDiscount > 0) {
          subTotal = Math.max(0, Math.round(basePrice * (100 - packDiscount) / 100));
        }

        var hasSubscriptionPlan =
          preferredTarget && (preferredTarget.planId != null || preferredTarget.groupId != null)
            ? Boolean(matchAllocationByTarget(variant, preferredTarget))
            : Boolean(sellingPlanId && variantHasPlanId(variant, sellingPlanId));

        // Sub each (per tube display): subTotal / pack size
        var subEach = Math.round(subTotal / packNum);

        var compareTotalForDisplay = 0;
        if (packDiscount > 0) {
          compareTotalForDisplay =
            subCompareTotal > subTotal
              ? subCompareTotal
              : baseCompare > subTotal
                ? baseCompare
                : basePrice;
        }

        return {
          variant: variant,
          packDiscount: packDiscount,
          subEach: subEach,
          subTotal: subTotal,
          subCompareTotal: compareTotalForDisplay,
          hasSubscriptionPlan: hasSubscriptionPlan,
          preferredTarget: preferredTarget
        };
      }

      function renderSubscribePricing() {
        var pricing = computeSubscribePricing(state.pack);
        if (!pricing) return;

        if (subEachEl) subEachEl.textContent = formatMoney(pricing.subEach, moneyFormat);
        if (subTotalEl) subTotalEl.textContent = formatMoney(pricing.subTotal, moneyFormat);

        if (subCompareEl) {
          if (pricing.packDiscount > 0 && pricing.subCompareTotal > pricing.subTotal) {
            subCompareEl.textContent = formatMoney(pricing.subCompareTotal, moneyFormat);
            subCompareEl.style.display = '';
          } else if (pricing.packDiscount > 0 && displayCompareFallback) {
            subCompareEl.textContent = displayCompareFallback;
            subCompareEl.style.display = '';
          } else {
            subCompareEl.style.display = 'none';
          }
        }

        if (subBadgeEl) {
          if (pricing.packDiscount > 0) {
            subBadgeEl.textContent = String(pricing.packDiscount) + '% ' + badgeSuffix;
            subBadgeEl.style.display = '';
          } else {
            subBadgeEl.style.display = 'none';
          }
        }

        packButtons.forEach(function (btn) {
          var btnPack = parseInt(btn.getAttribute('data-pack') || '2', 10);
          var isPackSelected =
            btnPack === state.pack && (state.type === 'sub' || state.oneTimeUsesPack);
          btn.classList.toggle('is-selected', isPackSelected);
          btn.setAttribute('aria-pressed', isPackSelected ? 'true' : 'false');
        });

        if (subPlan) {
          var planConfigured = Boolean(
            pricing.preferredTarget &&
              (pricing.preferredTarget.planId != null || pricing.preferredTarget.groupId != null)
          );
          subPlan.classList.toggle(
            'is-disabled',
            state.type === 'sub' && planConfigured && !pricing.hasSubscriptionPlan
          );
          subPlan.setAttribute(
            'title',
            state.type === 'sub' && planConfigured && !pricing.hasSubscriptionPlan
              ? 'Subscription plan for this pack is not available. Check selling plan ID mapping.'
              : ''
          );
        }

        return pricing;
      }

      function updateGummiesBadge() {
        if (!gummiesBadgeEl) return;
        var showBadge = state.type === 'sub' || state.oneTimeUsesPack;
        var gummies = GUMMIES_BY_PACK[state.pack] || 0;
        if (!showBadge || !gummies) {
          gummiesBadgeEl.hidden = true;
          return;
        }
        if (gummiesCountEl) gummiesCountEl.textContent = String(gummies);
        gummiesBadgeEl.hidden = false;
        gummiesBadgeEl.setAttribute('data-pack', String(state.pack));
        gummiesBadgeEl.classList.toggle('is-pack-4', state.pack === 4);
        gummiesBadgeEl.classList.toggle('is-pack-6', state.pack === 6);
      }

      function renderOneTimePricing() {
        if (state.oneTimeUsesPack) {
          var packVariant = resolveVariantForPack(state.pack);
          var packPrice = Number(packVariant && packVariant.price ? packVariant.price : 0);
          if (oneEachEl) oneEachEl.textContent = formatMoney(packPrice, moneyFormat);
          // Pack price is the full pack total, not a per-tube "each" price.
          if (onePriceLabelEl) onePriceLabelEl.textContent = 'total';
          return packVariant || resolveOneTimeVariant(variants, fallbackVariant);
        }

        var singleVariant = resolveOneTimeVariant(variants, fallbackVariant);
        var singlePrice = Number(singleVariant.price || 0);
        if (oneEachEl) oneEachEl.textContent = formatMoney(singlePrice, moneyFormat);
        if (onePriceLabelEl) onePriceLabelEl.textContent = 'each';
        return singleVariant;
      }

      function render() {
        var subscribePricing = renderSubscribePricing();
        var oneTimeVariant = renderOneTimePricing();

        if (packsEl) {
          packsEl.hidden = false;
          packsEl.setAttribute('aria-hidden', 'false');
        }

        if (state.type === 'one') {
          if (subPlan) subPlan.classList.toggle('is-selected', false);
          if (onePlan) onePlan.classList.toggle('is-selected', true);
          if (variantInput) variantInput.value = String(oneTimeVariant.id);
          if (cta) cta.disabled = !oneTimeVariant.available;
          updatePackImage(module, state.pack, 'one', state.oneTimeUsesPack);
          updateGummiesBadge();
          return;
        }

        if (subPlan) subPlan.classList.toggle('is-selected', true);
        if (onePlan) onePlan.classList.toggle('is-selected', false);

        if (subscribePricing && subscribePricing.variant) {
          if (variantInput) variantInput.value = String(subscribePricing.variant.id);
          if (cta) cta.disabled = !subscribePricing.variant.available;
        }

        updatePackImage(module, state.pack, 'sub', true);
        updateGummiesBadge();
      }

      if (subPlan) {
        subPlan.addEventListener('click', function () {
          state.type = 'sub';
          state.oneTimeUsesPack = true;
          render();
        });
      }
      if (onePlan) {
        onePlan.addEventListener('click', function () {
          // Keep current pack selection (e.g. 6 Pack) when switching back from Subscribe.
          state.type = 'one';
          render();
        });
      }
      packButtons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.stopPropagation();
          var next = parseInt(btn.getAttribute('data-pack') || '2', 10);
          if (!KEFEY_PACK_SIZES.includes(next)) return;
          state.pack = next;
          // Keep current purchase type; packs update one-time pricing when one-time is selected.
          state.oneTimeUsesPack = true;
          render();
        });
      });

      if (cta) {
        cta.addEventListener('click', function () {
          if (cta.dataset.kefeyLoading === 'true') return;

          if (state.type === 'one') {
            var oneVariant = state.oneTimeUsesPack
              ? resolveVariantForPack(state.pack)
              : resolveOneTimeVariant(variants, fallbackVariant);
            if (!oneVariant || !oneVariant.id) return;

            cta.dataset.kefeyLoading = 'true';
            cta.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: Number(oneVariant.id),
                quantity: 1,
                properties: buildKefeyLineProperties(
                  module,
                  state.oneTimeUsesPack ? state.pack : 1,
                  'one',
                  null,
                  state.oneTimeUsesPack
                )
              })
            })
              .then(function (res) {
                if (!res.ok) {
                  return res
                    .json()
                    .catch(function () {
                      return {};
                    })
                    .then(function (errBody) {
                      var msg =
                        (errBody && (errBody.description || errBody.message)) ||
                        'Failed to add item';
                      throw new Error(msg);
                    });
                }
                return res.json();
              })
              .then(function () {
                // Product CTA goes straight to checkout; header cart icon still opens /cart.
                window.location.href = '/checkout';
              })
              .catch(function (err) {
                console.error('[Kefey Purchase] Add to cart failed:', err && err.message ? err.message : err);
                cta.dataset.kefeyLoading = 'false';
                cta.disabled = false;
              });
            return;
          }

          var variant = resolveVariantForPack(state.pack);
          if (!variant || !variant.id) return;

          var preferredTarget = sellingPlanByPack[state.pack] || null;
          var packDiscount = discountByPack[state.pack];
          if (typeof packDiscount !== 'number' || isNaN(packDiscount)) packDiscount = displayDiscount;
          var sellingPlanId = sellingPlanIdForCart(variant, preferredTarget);
          if (sellingPlanId == null || !variantHasPlanId(variant, sellingPlanId)) {
            sellingPlanId = sellingPlanIdForCart(variant, null);
          }
          var chosenAllocation = matchAllocationByTarget(variant, preferredTarget);
          if (!chosenAllocation) chosenAllocation = firstRecurringAllocation(variant);
          if (chosenAllocation) {
            var chosenId = allocationPlanId(chosenAllocation);
            if (chosenId != null && variantHasPlanId(variant, chosenId)) sellingPlanId = chosenId;
          }
          if (
            state.type === 'sub' &&
            preferredTarget &&
            (preferredTarget.planId != null || preferredTarget.groupId != null) &&
            !matchAllocationByTarget(variant, preferredTarget)
          ) {
            console.error('[Kefey Purchase] Missing configured subscription target on selected variant for pack', state.pack, preferredTarget);
            return;
          }

          if (state.type === 'sub' && sellingPlanId != null && !variantHasPlanId(variant, sellingPlanId)) {
            sellingPlanId = null;
          }

          var payload = {
            id: Number(variant.id),
            quantity: cartQuantityForPack(variant, state.pack),
            properties: buildKefeyLineProperties(module, state.pack, 'sub', sellingPlanId, true)
          };
          if (state.type === 'sub' && sellingPlanId != null && variantHasPlanId(variant, sellingPlanId)) {
            payload.selling_plan = sellingPlanId;
          }

          cta.dataset.kefeyLoading = 'true';
          cta.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (res) {
              if (!res.ok) {
                return res
                  .json()
                  .catch(function () {
                    return {};
                  })
                  .then(function (errBody) {
                    var msg =
                      (errBody && (errBody.description || errBody.message)) ||
                      'Failed to add item';
                    throw new Error(msg);
                  });
              }
              return res.json();
            })
            .then(function () {
              // Product CTA goes straight to checkout; header cart icon still opens /cart.
              window.location.href = '/checkout';
            })
            .catch(function (err) {
              console.error('[Kefey Purchase] Add to cart failed:', err && err.message ? err.message : err);
              cta.dataset.kefeyLoading = 'false';
              cta.disabled = false;
            });
        });
      }

      render();
    });
  }

  function initHeroScrollCta(scope) {
    var links = (scope || document).querySelectorAll('[data-kefey-scroll-cta]');
    if (!links.length) return;

    links.forEach(function (link) {
      if (link.dataset.kefeyScrollBound === 'true') return;
      link.dataset.kefeyScrollBound = 'true';

      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;

        var id = href.slice(1);
        var target = id ? document.getElementById(id) : null;

        if (!target) {
          target = document.getElementById('kefey-purchase') || document.querySelector('[data-kefey-purchase]');
        }

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init(scope) {
    initIngredientsCarousels(scope);
    initCertCarousels(scope);
    initFinalCtaSlider(scope);
    initFaqAria(scope);
    initPurchaseModule(scope);
    initHeroScrollCta(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (evt) { init(evt.target); });
})();
